import { render, staticRenderFns } from "./ModalCut.vue?vue&type=template&id=35bec027&scoped=true&"
import script from "./ModalCut.vue?vue&type=script&lang=js&"
export * from "./ModalCut.vue?vue&type=script&lang=js&"
import style0 from "./ModalCut.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalCut.vue?vue&type=style&index=1&id=35bec027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bec027",
  null
  
)

export default component.exports